/*************************************************************************
 *
 * KLEARNOW CONFIDENTIAL
 * __________________
 *
 *  Copyright (c) 2018 - 2020 KLEARNOW Corporation.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of KLEARNOW Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KLEARNOW Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KLEARNOW Corporation.
 */

import React, { Component } from 'react'
import { Icon, Header, Button } from 'semantic-ui-react'
import { getHTSData,getHSDtlList } from '../api/htsRequests'
import get from 'lodash/get'
export default class HTSCodePopup extends Component {
  constructor() {
    super()
    this.state = {
      root: '',
      codes: [],
      nextCodes: [],
      selectedNode: null,
      selectedCodes_pg: [],
      pickedforui_sendtoparent: null,
      toggle: false,
      selectedFirst: '',
      selectedLast: '',
      show: [],
      showLast: [],
      clickedIndex: '',
      htsEllipses: true,
      isLoading: false,
      treeError: null
    }
    this.getRoot = this.getRoot.bind(this)

    this.setWrapperRef = this.setWrapperRef.bind(this)
    this.handlePointerOutside = this.handlePointerOutside.bind(this)
    this.handleDocumentKeyDown = this.handleDocumentKeyDown.bind(this)
  }

  setWrapperRef(node) {
    this.wrapperRef = node
  }
  lastnode_GB = null;

  isEventInsideAnchor = (event) => {
    const { anchorId } = this.props
    if (!anchorId) return false
    const anchorEl = document.getElementById(anchorId)
    if (!anchorEl) return false
    return anchorEl === event.target || anchorEl.contains(event.target)
  }

  getAnchorElement = () => {
    const { anchorId } = this.props
    if (!anchorId) return null
    return document.getElementById(anchorId)
  }

  isAnchorFocused = () => {
    const anchorEl = this.getAnchorElement()
    const active = document.activeElement
    if (!active || !anchorEl) return false
    // InputField sets id on Semantic Input; activeElement is usually the inner <input>
    return active === anchorEl || anchorEl.contains(active)
  }

  handlePointerOutside = (event) => {
    if (!this.wrapperRef) return
    if (this.wrapperRef.contains(event.target)) return
    if (this.isEventInsideAnchor(event)) return
    // Keep open when using the HTS dropdown trigger next to the field
    if (event.target?.closest?.('.hts-dropdown-icon')) return

    this.closePane()
    // Blur after unmount so DutyItem onBlur runs with showhtspopup already false and can persist.
    requestAnimationFrame(() => {
      const anchorEl = this.getAnchorElement()
      if (!anchorEl) return
      const active = document.activeElement
      if (active === anchorEl || anchorEl.contains(active)) {
        (active === anchorEl ? anchorEl : active).blur()
      }
    })
  }

  handleDocumentKeyDown = (event) => {
    const isEscape = event.key === 'Escape' || event.key === 'Esc' || event.keyCode === 27
    const isTab = event.key === 'Tab' || event.keyCode === 9

    if (isEscape) {
      // Popup is mounted only while open — Esc always dismisses it
      event.preventDefault()
      event.stopPropagation()
      this.closePane()
      return
    }

    if (isTab && this.isAnchorFocused()) {
      // Close on tab-away from the HTS field; let default focus move + blur persist
      this.closePane()
    }
  }

  componentDidMount(){
    if (this.props.code) {
      this.getRoot(this.props.code.split('.').join(""), true)
    }
    // Defer so the click that opened the popup does not immediately close it
    this.outsideClickListenTimer = setTimeout(() => {
      document.addEventListener('mousedown', this.handlePointerOutside, true)
      document.addEventListener('keydown', this.handleDocumentKeyDown, true)
    }, 0)
  }

  componentWillUnmount() {
    clearTimeout(this.outsideClickListenTimer)
    document.removeEventListener('mousedown', this.handlePointerOutside, true)
    document.removeEventListener('keydown', this.handleDocumentKeyDown, true)
    clearTimeout(this.debouncehts)
  }

  componentWillReceiveProps(nextProps) {
    // if(nextProps.code && nextProps.code.length>8){
    //   return;
      
    // }
    // Digit-only compare: props may include dots while state.root does not.
    // Mismatch + isCompleteCode was auto-closing additional (98/99) HTS trees.
    const nextCode = (nextProps.code || '').replace(/[.]/g, '')
    const currentRoot = (this.state.root || '').replace(/[.]/g, '')
    if (nextCode !== currentRoot) {
      this.getRoot(nextProps.code, true)
      return;
    }
    let useCode = this.props.code
    if (this.props.code !== this.props.mapCode) {
      useCode = this.props.mapCode.split('.')
      useCode = useCode[0].concat(useCode[1])
      this.getRoot(useCode, true)
    }
  }


  // sortCodes = (data) => {
  //   let sortCodesBy = (name, bool, cb) => {
  //     let key = cb ?
  //       (x) => {
  //         return cb(x[name])
  //       } :
  //       (x) => {
  //         return x[name]
  //       }

  //     bool = !bool ? 1 : -1
  //     return (a, b) => {
  //       return a = key(a), b = key(b), bool * ((a > b) - (b > a))
  //     }
  //   }
  //   data.forEach((elem) => {
  //     elem.hsCode = elem.hsCode.split('.').join('')
  //   })
  //   data.sort(sortCodesBy('hsCode', false, parseInt))
  //   data.forEach(elem => {
  //     let len = elem.hsCode.length
  //     if (len === 10) {
  //       elem.hsCode = elem.hsCode.match(/(.{4})(.{2})(.{4})/).splice(1).join('.')
  //     }
  //     if (len === 8) {
  //       elem.hsCode = elem.hsCode.match(/(.{4})(.{2})(.{2})/).splice(1).join('.')
  //     }
  //     if (len === 6) {
  //       elem.hsCode = elem.hsCode.match(/(.{4})(.{2})/).splice(1).join('.')
  //     }
  //     if (len === 4) {
  //       elem.hsCode = elem.hsCode.match(/(.{4})/).splice(1).join('.')
  //     }
  //   })
  //   return data
  // }

  uponeLevel = () => {
    let splitroot = this.state.root.split('.');
    if(splitroot.length > 1){
      splitroot.pop()
      this.setState({root:splitroot.join("")});
    }
    this.getCodes();

  }
  getCodes = async () => {
    this.setState({ isLoading: true, treeError: null })
    try {
      const response = await getHTSData(this.state.root.split('.').join("").substr(0, 6) || "", this.props.country, this.props.shipmentETA)
      let selected = [this.state.root.substr(0, 4),
      this.state.root.substr(0, 4) + "." + this.state.root.substr(4, 2),
      this.state.root.substr(0, 4) + "." + this.state.root.substr(4, 2) + "." + this.state.root.substr(6, 2),
      this.state.root.substr(0, 4) + "." + this.state.root.substr(4, 2) + "." + this.state.root.substr(6, 2) + "." + this.state.root.substr(8, 2),
      ]

      let treehts_lk = get(response, 'data.eventMessage', {})
      if (!treehts_lk?.htsCode) {
        this.setState({ isLoading: false, treehts_lk: null, treeError: true })
        return
      }
      this.setState({
        treehts_lk: treehts_lk,
        selectedNode: treehts_lk,
        selectedCodes_pg: selected,
        isLoading: false,
        treeError: null
      })
    } catch (e) {
      this.setState({ isLoading: false, treehts_lk: null, treeError: true })
    }
  }

  isLeafNode = (mynode) => {
    if(!mynode)return false
    if(mynode.htsCode.length < 6) return false;
    if(this.props.country === "UK" && this.props.declarationTypeValue==="EX" && mynode.htsCode.replace(/\./g, "").length === 8) return true
    return !mynode.htsNodes || mynode.htsNodes.length == 0;
  }
  isCompleteCode = (code) => {
    if(!code)return false;
    let codecleaned = code.split('.').join('').trim();
    if( this.props.country !== "UK" && codecleaned.length > 10) return true;
    let firsttwo = parseInt(codecleaned.substr(0,2));
    if(firsttwo>97 && firsttwo<100){
      if(codecleaned.length===8) return true;
    }
    if(this.props.country === "UK" && this.props.hasOwnProperty("declarationTypeValue") === true && this.props.declarationTypeValue==="EX" && codecleaned.replace(/\./g, "").length > 10) return true 
    if(this.props.country === "UK" && this.props.hasOwnProperty("declarationTypeValue") === true && this.props.declarationTypeValue==="IM" && codecleaned.replace(/\./g, "").length > 10) return true 
   
    return false
  }

  debouncehts = null;
  getRoot = (rootCode, iconClick) => {
    let code = (rootCode || '').replace(/[.]/g, '')
    // Do not auto-close for "complete" codes (e.g. 8-digit chapter 98/99).
    // Close is owned by outside-click / Esc / Tab / leaf select.
    clearTimeout(this.debouncehts);
    const applyRoot = () => {
      if (code !== undefined) {
        this.setState({
          root: code.trim(),
        }, () => this.getCodes())
      }
    };
    if (iconClick) {
      applyRoot();
    } else {
      this.debouncehts = setTimeout(applyRoot, 500);
    }
  }
  closePane = () => {
    // Unmount immediately — deferring hidehtspopup left treehts_lk null with
    // showhtspopup still true, so the skeleton showed and a 2nd outside click was needed.
    this.props.hidehtspopup && this.props.hidehtspopup()
  }

  handleHTSNodeSelectAndPossiblyClose = (e, node_xz) => {
    // Prevent <a href="#"> from stealing focus / navigating — that blur race
    // intermittently left the field with the old HTS (especially additional lines).
    e && e.preventDefault && e.preventDefault()
    e && e.stopPropagation && e.stopPropagation()
    this.setState({ selectedNode: node_xz })
    if (this.isLeafNode(node_xz)) {
      this.props.callbackwhenChanged(node_xz.htsCode, true)
      this.setState({ pickedforui_sendtoparent: node_xz })
      this.closePane()
    } else {
      this.handleHTSNodeSelect(e, node_xz)
    }
  }

  handleHTSNodeSelect = (e,node_xz) => {
    //console.log('kethrhtr: ', e.keyCode  );
    if(e.keyCode == '38' || e.keyCode == '39' || e.keyCode == '40' || e.keyCode =='37' || e.keyCode == '13' || e.keyCode == '32' || e.keyCode == '8'){
      this.handleHTSNodeKeydown(e,node_xz);
      return;
    }
    if(e.keyCode == '27'){//esc
      this.closePane();
    }
    if(!e.keyCode){///Onclick
       this.setState({selectedNode:node_xz});
       if(node_xz.htsNodes){
       if(this.state.selectedCodes_pg.indexOf(node_xz.htsCode) == -1){
          this.setState({selectedCodes_pg:
              this.state.selectedCodes_pg.concat(node_xz.htsCode)
          });
        } else {
          this.setState({selectedCode_pg:
              this.state.selectedCodes_pg.splice(this.state.selectedCodes_pg.indexOf(node_xz.htsCode),1)
          });
        }
      }
      if (this.isLeafNode(node_xz) || node_xz.htsCode.length == 4) {
        this.props.callbackwhenChanged(node_xz.htsCode, this.isLeafNode(node_xz));
      }
    }


  }

  openNode_kl = (e,node_xz) => {
    var nodeindex = this.state.selectedCodes_pg.indexOf(node_xz.htsCode);
    
    if(nodeindex >= 0){
      this.setState({selectedCode_pg:
          this.state.selectedCodes_pg.splice(nodeindex,1)
      });
    } else {
      if(node_xz.htsNodes){
        this.setState({selectedCodes_pg:
            this.state.selectedCodes_pg.concat(node_xz.htsCode)
        });
      }

    }
  }
  // componentDidUpdate = () => {

  //   let htscodeOfSelected = this.state.selectedNode && this.state.selectedNode.htsCode 
  //   && (this.state.selectedNode.htsCode.replace(/[.]/g, '').length == 8 || this.state.selectedNode.htsCode.replace(/[.]/g, '').length == 10);
  //   if(htscodeOfSelected && !this.state["ABCZkey"+htscodeOfSelected]){
  //     let addToState = {};
  //     addToState["ABCZkey"+htscodeOfSelected]={Loading:""};
  //     this.setState(addToState)
  //     getHSDtlList([htscodeOfSelected])
  //     .then(response => {
  //       let hsDataDtl = _.get(response, 'data.eventMessage.hsDataDtlList[0]', false);
  //       addToState = {};
  //       addToState["ABCZkey"+htscodeOfSelected]=hsDataDtl || {Loading:"No record found"};
  //       this.setState(addToState)
        
  //     });
  //   }

  // }
  handleHTSNodeHighlight = (e,node_xz) => {
    this.setState({selectedNode: node_xz})
    
  }
  handleHTSNodeKeydown = (e) => {
    const node_xz = this.state.selectedNode;
    if(!node_xz)node_xz = this.state.treehts_lk;
    //console.log('e,node_xz: ', e,node_xz);
    //console.log('ethrhtr: ', e.keyCode  );
    if (e.keyCode == '38') {//up
        this.setState({selectedNode:  node_xz.prev || node_xz})
     //   document.getElementById((node_xz.prev || node_xz)+"HTSBYID")&&document.getElementById((node_xz.prev || node_xz)+"HTSBYID").focus()
    }
    else if (e.keyCode == '40') {//down
        this.setState({selectedNode:node_xz.next || node_xz})
      //  document.getElementById((node_xz.next || node_xz)+"HTSBYID")&&document.getElementById((node_xz.next || node_xz)+"HTSBYID").focus()
    }
    else if (e.keyCode == '37') {//left
      var nodeindex = this.state.selectedCodes_pg.indexOf(node_xz.htsCode);
      if(nodeindex >= 0){
        if(nodeindex > 0){
          this.setState({selectedCode_pg:
              this.state.selectedCodes_pg.splice(nodeindex,1)
          });
        }
      } else {
        this.setState({selectedNode:  node_xz.parentnode || node_xz})
      }
    } 
    else if (e.keyCode == '8') {//backspace
      this.uponeLevel();
    }
    else if (e.keyCode == '39') {//right
      var nodeindex = this.state.selectedCodes_pg.indexOf(node_xz.htsCode);
      if(nodeindex < 0 && node_xz.htsNodes){
        this.setState({selectedCodes_pg:
            this.state.selectedCodes_pg.concat(node_xz.htsCode)
        });
      } else {
        if(node_xz.htsNodes){
          this.setState({selectedNode:node_xz.htsNodes[0]})
       //   document.getElementById(node_xz.htsNodes[0].htsCode+"HTSBYID")&& document.getElementById(node_xz.htsNodes[0].htsCode+"HTSBYID").focus();
        }
      } 

    } else if (e.keyCode == '13' || e.keyCode == '32') {
      this.props.callbackwhenChanged(node_xz.htsCode, this.isLeafNode(node_xz));
      this.setState({ pickedforui_sendtoparent: node_xz })
      if (this.props.country !== "UK" && !node_xz.htsNodes) {// no children? You've come to a leaf. close the pane
        this.closePane();
      } else if (this.props.country === "UK" && this.props.declarationTypeValue === "EX" && node_xz.htsCode.replace(/\./g, "").length === 8) {
        this.closePane();
      }
      else if (this.props.country === "UK" && this.props.declarationTypeValue === "IM" && node_xz.htsCode.replace(/\./g, "").length === 10) {
        this.closePane();
      }
    }
    e.preventDefault && e.preventDefault();


  }

  
  renderOneNode = (node_xz,parentnode,depthvv) => {
   
    if(!node_xz || !node_xz.htsCode)return <div></div>

    node_xz.prev = this.lastnode_GB;
    if(node_xz.prev){
      node_xz.prev.next = node_xz;
    }
    this.lastnode_GB = node_xz;
    node_xz.parentnode = parentnode;
    
      const backendToHuman = {
      shortDesc: {desc: 'Display description ', pos: 4},
      qtyUnit1: {desc: 'Quantity units', pos: 3},
      generalDuty: {desc: 'General Duty Rate', pos: 2},
      specialDuty: {desc: 'Special Duty Rate', pos: 1},
      //pga tariff
      //special tariff
      //other special flags
      //special programs
      //Last Updated
    }
    function keysorter(arrayOfKeys){
        return arrayOfKeys.sort((a,b)=>{
          if(!backendToHuman[a])return 1;
          if(!backendToHuman[b])return -1;
          return backendToHuman[a].pos > backendToHuman[b].pos;

        });
    }

    return <li className={('lihtslength'+node_xz.htsCode.length)}>
      <a type="text"  href="#" style={{paddingLeft:(depthvv*16)+'px'}}
      id={node_xz.htsCode+ "HTSBYID"}
      className={'htsnode ' + ((this.state.selectedNode==node_xz)?' selected ':' ')  + 
      (node_xz.htsNodes?' haschildren ':' nochildren ') +
     ((this.state.selectedCodes_pg.indexOf(node_xz.htsCode)>=0)?" highlightedrow ":" " )+
     ('htslength'+node_xz.htsCode.replace(/[.]/g, '').length)
    
    }
      
      onKeyDown={(e) => {
        this.handleHTSNodeSelect(e,node_xz)
      }}
      
      // onDoubleClick={(e) => {

      // }}
      >
        
        <span  >
       
        <Button
          className={"htsicon "+( (this.state.selectedCodes_pg.indexOf(node_xz.htsCode)>=0)?" rotated ":" " )} icon='angle right' style={{visibility:node_xz.htsNodes?'visible':'hidden'}}
          onClick={(e) => {
            this.handleHTSNodeSelect(e,node_xz)
          }}
          
        />
        <Button
          className={"htsicon greencheck"} icon='check'
          style={{display:((node_xz == this.state.pickedforui_sendtoparent)?'inline':'none')}}
        />
          <span 
                onClick={(e) => {           
                    this.handleHTSNodeSelectAndPossiblyClose(e,node_xz)
                }}>
      {node_xz.htsCode.substr(0,4)}<b>{node_xz.htsCode.substr(4)}</b> 
            &nbsp;&nbsp;{(node_xz.htsScheduleDescription && node_xz.htsScheduleDescription.substring(0, 60)) || ""} 
          </span>
            &nbsp;&nbsp;
          {parentnode && parentnode.tariff &&parentnode.tariff.usTariff && <span onClick={(e) => {this.handleHTSNodeHighlight(e,node_xz)}} style={{color:'blue'}}>
               {this.state.selectedNode && this.state.selectedNode.htsCode && (this.state.selectedNode.htsCode == node_xz.htsCode) ? '( - )' : '( + )'}
               </span>}
      </span>
        {this.state.selectedNode && this.state.selectedNode.htsCode && (this.state.selectedNode.htsCode == node_xz.htsCode) &&
             parentnode && parentnode.tariff &&parentnode.tariff.usTariff &&
              <ul><li className="showtariffs">

              General Tax Rate: {parentnode.tariff &&parentnode.tariff.usTariff && parentnode.tariff.usTariff.generalTaxRate}<br/>
              Other Tax Rate: {parentnode.tariff &&parentnode.tariff.usTariff && parentnode.tariff.usTariff.otherTaxRate}<br/>
              Special Tax Rate: {parentnode.tariff &&parentnode.tariff.usTariff && parentnode.tariff.usTariff.specialTaxRate}<br/>
              </li></ul>
            }
      </a>
      {node_xz.htsNodes && (this.state.selectedCodes_pg.indexOf(node_xz.htsCode) >= 0) && node_xz.htsNodes.map((onenode,iiiibi)=>{
        return <ul key={iiiibi}>
          {this.renderOneNode(onenode,node_xz,depthvv+1)}
          </ul>
      })}
    
    
    </li>
    
  }
  onPopupMouseDown = (e) => {
    // Keep focus on the HTS input while interacting with the tree
    e.preventDefault()
  }

  render() {
    const popupClass = 'hts-popup-container-es' + (this.state.isLoading ? ' hts-popup-container-es--loading' : '')
    if (this.state.treeError && !this.state.isLoading) {
      return (
        <div
          id={this.props.popupId}
          tabIndex={-1}
          className={popupClass}
          ref={this.setWrapperRef}
          onMouseDown={this.onPopupMouseDown}
        >
          <div style={{ marginBottom: '15px' }}>
            <b> HTS Selector codes for {this.state.root.substr(0, 4)}{this.state.root.substr(4, 2) && ('.' + this.state.root.substr(4, 2))}{this.state.root.substr(6, 2) && ('.' + this.state.root.substr(6, 2))}{this.state.root.substr(8, 2) && ('.' + this.state.root.substr(8, 2))} </b>
            <Button className={"htsiconclose"} icon='close' onClick={() => this.closePane()} />
          </div>
          <div className="hts-popup-empty">
            <Icon name="search" />
            <div>No results found</div>
          </div>
        </div>
      )
    }
    if (!this.state.treehts_lk) {
      // if the code is empty, return null
      if(!this.props.code.length) return null;
      return (
        <div
          id={this.props.popupId}
          tabIndex={-1}
          className={popupClass}
          ref={this.setWrapperRef}
          onMouseDown={this.onPopupMouseDown}
        >
          <div className="hts-popup-skeleton" style={{ marginBottom: '15px' }}>
            <div className="hts-popup-skeleton__line hts-popup-skeleton__title" />
            <div className="hts-popup-skeleton__line hts-popup-skeleton__close" />
          </div>
          <div className={'hts-popup-list hts-popup-skeleton'}>
            <div className="hts-popup-skeleton__line" />
            <div className="hts-popup-skeleton__line" />
            <div className="hts-popup-skeleton__line" />
            <div className="hts-popup-skeleton__line" />
            <div className="hts-popup-skeleton__line" />
            <div className="hts-popup-skeleton__line" />
          </div>
        </div>
      );
    }
    if (this.props.disabled) return null;
    return (
      <div
        id={this.props.popupId}
        tabIndex={-1}
        className={popupClass}
        ref={this.setWrapperRef}
        onMouseDown={this.onPopupMouseDown}
      >
        <div style={{ marginBottom: '15px' }}>
          {' '}
          <b> HTS Selector codes for {this.state.root.substr(0, 4)}{this.state.root.substr(4, 2) && ('.' + this.state.root.substr(4, 2))}{this.state.root.substr(6, 2) && ('.' + this.state.root.substr(6, 2))}{this.state.root.substr(8, 2) && ('.' + this.state.root.substr(8, 2))} </b>

          <Button
            className={"htsiconclose"} icon='close' onClick={() => this.closePane()}
          />
          <span className="legendholder">?
            <div>
              Keys:<br />
              <b>Left:</b> Close HTS/Go to higher HTSes<br />
              <b>Right:</b> Open HTS/Go to lower HTSes<br />
              <b>Up:</b> Navigate Upward<br />
              <b>Down:</b> Navigate Downward<br />
              <b>Enter/Spacebar:</b> Select HTS<br />
              <b>Esc:</b> Close pane<br />
              <b>Backspace:</b> Search on a more general HTS<br />
              <b>Single-click:</b> Focus an HTS<br />
              <b>Double-click:</b> Select and close<br />
            </div>
          </span>
        </div>
        <div className={'hts-popup-list'}>
          {this.state.root.split('.').length > 1 &&
            <span style={{ cursor: "pointer" }} title="Hotkey: backspace" onClick={() => this.uponeLevel()}>..[Up one level]</span>
          }
          <ul>{this.renderOneNode(this.state.treehts_lk, null, 0)}</ul>
        </div>
      </div>
    )
  }
}
